import { render, staticRenderFns } from "./SetServiceWin.vue?vue&type=template&id=c327c1ce&"
import script from "./SetServiceWin.vue?vue&type=script&lang=js&"
export * from "./SetServiceWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports